import React from "react";
import { GOVGR_ACCORDION } from "../../conf/styles/GovGrAccordion";
import AccordionSections from "./AccordionSections";

const GovGrAccordion = ({
  accordionItems = [
    {
      id: "Header 1",
      path: "/hi",
      children: [{ id: "Link1", component: <>p</>, path: "/hi" }],
    },
    {
      id: "Header 2",
      path: "/hi",
      children: [{ id: "Link2", component: <>p</>, path: "/hi2" }],
    },
    {
      id: "Header 3",
      path: "/hi",
      children: [{ id: "Link2", component: <>p</>, path: "/hi2" }],
    },
    {
      id: "Header 3",
      path: "/hi3",
    },
    {
      id: "Header 3",
      path: "/hi3",
    },
    {
      id: "Header 3",
      path: "/hi3",
    },
    {
      id: "Header 3",
      path: "/hi3",
    },
    {
      id: "Header 3",
      path: "/hi3",
    },
    {
      id: "Header 3",
      path: "/hi3",
    },
    {
      id: "Header 3",
      path: "/hi3",
    },
    {
      id: "Header 3",
      path: "/hi3",
    },
  ],
}) => {
  return (
    <div className={`${GOVGR_ACCORDION}`}>
      <AccordionSections table={accordionItems} />
    </div>
  );
};

export default GovGrAccordion;
